import { render, staticRenderFns } from "./textbox.vue?vue&type=template&id=140cfab8&scoped=true&lang=pug&"
import script from "./textbox.vue?vue&type=script&lang=js&"
export * from "./textbox.vue?vue&type=script&lang=js&"
import style0 from "./textbox.vue?vue&type=style&index=0&id=140cfab8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140cfab8",
  null
  
)

export default component.exports